import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import Nav from '../../components/Nav/Nav';
import Footer from '../../components/Footer/Footer';
import DashboardNav from '../../components/Nav/DashboardNav'
import { useNavigate } from 'react-router-dom'
import privacyImage from './Assets/privacy.png'
import { jwtDecode } from 'jwt-decode'
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';
import arrowdown from './Assets/arrowDown.svg'

const formatAnswer = (answer) => {
    if (typeof answer === 'string') {
        return <p>{answer}</p>;
    }

    if (Array.isArray(answer)) {
        return (
            <>
                {answer.map((part, index) => {
                    switch (part.type) {
                        case 'bold':
                            return <span key={index} className="font-black">{part.content}</span>;
                        case 'gray':
                            return <span key={index} className="text-ravash font-medium">{part.content}</span>;
                        case 'heading':
                            return <span key={index} className="font-black ">{part.content}</span>;
                        case 'list':
                            return (
                                <ul key={index} className="ml-4 list-disc text-ravash  font-medium">
                                    {part.content.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                </ul>
                            );
                        case 'innerlist':
                            return (
                                <ul key={index} className="ml-20 list-disc ">
                                    {part.content.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                </ul>
                            );
                        case 'newline':
                            return <p key={index} className="mt-2"></p>;
                        case 'space':
                            return <p key={index} className="mt-9"></p>;

                        case 'link':
                            return <a href="mailto:contactus@goodifly.com" className=" underline text-[#EB0728] lg:w-[779px] text-[16px] sm:text-[18px] font-normal lg:leading-[21.83px] leading-[19.41px]">
                                <span key={index} >{part.content}</span>
                            </a>;

                        case 'indent':
                            return <p key={index} className="ml-5"></p>;
                        case 'text':
                        default:
                            return <span key={index} className="font-medium"> {part.content}</span>;
                    }
                })}
            </>
        );
    }

    return null;
};


// Individual FAQ Item component
const PolicyItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false); // State to track if answer is visible

    const toggleAnswer = () => {
        setIsOpen(!isOpen); // Toggle the state when button is clicked
    };

    return (

        <div
            onClick={toggleAnswer}
            className={`border flex flex-col mb-[14px] items-start justify-center rounded-[10px] lg:mx-0 lg:pl-[23px] pl-[15px] pr-[13px]  cursor-pointer overflow-hidden transition-all duration-200 ease-out  ${isOpen ? 'pt-[15px] pb-[90px] lg:py-[19px] md:py-[19px]' : 'py-[19px] md:py-[19px] lg:py-[19px] h-auto'
                }`}
            style={{ transitionProperty: 'border-color, border-width' }} >
            {/* Question and icon */}
            <div className="flex items-center justify-bectween w-full">
                <h1 className=" text-sm font-black  flex-grow  ">
                    {question}
                </h1>
                <img
                    src={arrowdown} alt='open' className={`${isOpen && 'rotate-180'}`}/>
            </div>

            {/* Conditionally render the answer */}
            <div
                className={`flex justify-between items-center ${isOpen ? 'h-auto opacity-100' : 'max-h-0 opacity-0'
                    }`}>
                <span className="lg:mt-[34px] mt-[39px]  text-sm font-medium  flex-grow  "> {formatAnswer(answer)}</span>
            </div>
        </div>

    );
};

const PrivacyPolicy = () => {

    const policy = [

        {
            question: '1. Information we collect',
            answer: [
                { type: 'bold', content: 'Personal Data ' },
                { type: 'newline' },
                { type: 'gray', content: 'When you use our Service, we may ask for personally identifiable information, including but not limited to: ' },
                { type: 'list', content: ['Name', 'Email address', 'Usage data'] },
                { type: 'space' },
                { type: 'bold', content: 'Usage Data ' },
                { type: 'newline' },
                { type: 'gray', content: 'We automatically collect certain data when you interact with our Service, including:' },
                { type: 'list', content: ['Your device’s IP address', 'Browser type and version', 'Pages visited and time spent on our Service', 'Device identifiers and diagnostic data',] },
                { type: 'space' },
                { type: 'bold', content: 'Information collected through Mobile App ' },
                { type: 'newline' },
                { type: 'gray', content: 'With your permission, we may collect:' },
                { type: 'list', content: ['Location data to enhance Service features', 'Contacts data for app functionality (if applicable)', ] },
                { type: 'space' },
                { type: 'gray', content: 'You can manage these permissions in your device settings at any time.' },
            ]
        },

        {
            question: '2. How we use your data?',
            answer: [
                { type: 'newline' },
                { type: 'gray', content: 'We use your personal data for the following purposes: ' },
                { type: 'list', content: ['To provide, maintain, and improve our Service', 'To manage your account and user experience', 'To communicate with you about updates, features, and support','To analyze usage trends and enhance our Service','To enforce our policies and comply with legal obligation'], },
            ]
        },
        {
            question: '3. Sharing your data',
            answer: [
                { type: 'newline' },
                { type: 'gray', content: 'We may share your data in the following cases: ' },
                { type: 'list', content: ['With service providers - Third-party companies that assist in operating our Service', 'For business transactions - If our company undergoes a merger, acquisition, or asset sale', 'With legal authorities - If required to comply with legal obligations or protect rights and safety','With your consent – In any other instance where you explicitly agree', ], },
            ]
        },

        {
            question: '4. Data retention & Security',
            answer: [
                
                { type: 'newline' },
                { type: 'list', content: ['We retain your personal data only as long as necessary for the stated purposes or as required by law.', 'We implement security measures to protect your data but cannot guarantee absolute security due to the nature of online transmissions.',] },
            ]
        },
        {
            question: '5. Your rights & choices',
            answer: [
                
                { type: 'newline' },
                { type: 'list', content: ['Access & control – You can update or delete your personal data by contacting us.', 'Opt-out – You can disable tracking features via your device or browser settings.','Third-party links – Our service may contain links to external websites, which have separate privacy policies beyond our control.'] },

                
            ]
        },
        {
            question: "6. Children's privacy",
            answer: [
                
                { type: 'newline' },
                { type: 'gray', content: 'Our Service is not intended for users under 13. We do not knowingly collect data from children.' },
                { type: 'newline' },
                { type: 'gray', content: 'If you believe a child has provided us with personal data, please contact us for removal.' },


                
            ]
        },
        {
            question: "7. Updates to this policy",
            answer: [
                
                { type: 'newline' },
                { type: 'gray', content: 'We may update this Privacy Policy periodically. Changes will be posted here with an updated' }, 
                { type: 'bold',content: ' "Last updated" '}, 
                {type: 'gray', content: 'date. Significant updates will be communicated via email or a notice on our platform.' },


                
            ]
        },
        {
            question: "8. Contact us",
            answer: [
                
                { type: 'newline' },
                { type: 'gray', content: 'If you have any questions about this Privacy Policy, you can contact us:' },
                { type: 'list', content: [' Email: info@rateavendor.com', 'Website: rateavendor.com/contact',] },


                
            ]
        },
        
    ];



    const [user, setUser] = useState(null)
    const navigate = useNavigate()

    // Decode the data 
    function decodeData(data) {
        return atob(data); // Base64 encoding
    }
    useEffect(() => {
        const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        // Decode the JWT token
        const decodedToken = storeToken ? decodeData(storeToken) : null;
        const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
        if (userInfo) {

            setUser(userInfo?.user)
        }

    }, [navigate])

    return (
        <div className='overflow-x-hidden  '>

            {user ? <DashboardNav /> : <Nav />}
            <div className="pt-[96px] md:pt-[137px] px-[16px]  md:px-[32px] xl:px-[64px] flex flex-col justify-center items-center ">
                <div className="flex flex-col items-center mb-8 ">
                    <img src={privacyImage} alt="siteguidelines" className="w-[91px] h-[104px] lg:w-[158px] lg:h-[181px]" />
                    <h1 className="text-[24px] leading-[100%] lg:text-xxl font-black mt-[15px] ">Privacy Policy</h1>
                </div>
                <div className='w-full px-[18px]  md:px-[25px]  lg:px-[29px]  xl:px-[37px] pt-[16px] md:pt-[28px] xl:pt-[36px] bg-ravbg rounded-[10px] pb-[76px]'>
                    <section className="mb-6 font-medium">
                        <h2 className="text-sm font-black ">Last updated: (7th March 2024)</h2>
                        <p className="text-sm  text-ravash mt-2 w-[1024px]">
                            Rate A Vendor is committed to protecting
                            your privacy. This Privacy Policy explains
                            how we collect, use, disclose, and
                            safeguard your personal information
                            when you use our website, mobile
                            application, or any related services
                            (collectively, the "Service"). By using the
                            Service, you consent to the collection
                            and use of your information as
                            described in this Privacy Policy.

                        </p>
                    </section>
                    <section className='w-full flex flex-col md:flex-row  md:justify-between md:gap-[18px] lg:gap-4'>
                        <span className='flex-[1]'>{policy.slice(0,4).map((policy, index) => (
                            <PolicyItem key={index} question={policy.question} answer={policy.answer} />
                        ))}</span>
                         <span className='flex-[1]' >{policy.slice(4,8).map((policy, index) => (
                            <PolicyItem key={index} question={policy.question} answer={policy.answer} />
                        ))}</span>
                    </section>

                </div>
            </div>
            <Footer />
        </div>

    );
};

export default PrivacyPolicy;